import React, {ReactElement, cloneElement, useId} from 'react';

import Tooltip from 'src/components/tooltip';

interface Props {
  children: ReactElement;
}

const NewTabTooltip = ({children}: Props) => {
  const descriptionId = useId();

  return (
    <>
      <Tooltip title="Opens in new tab" aria-label={undefined}>
        {cloneElement(children, {'aria-describedby': descriptionId})}
      </Tooltip>
      <span id={descriptionId} className="sr-only">
        (opens in new tab)
      </span>
    </>
  );
};

export default NewTabTooltip;
